export default {
    name: 'NykAlert',
    props: {
        type: {
            type: String,
            required: true,
        }
    }
}
